import React, { useState, forwardRef, useRef, useImperativeHandle } from 'react';
import classNames from '../classNames';
import useButtonListeners from '../hooks/useButtonListeners';

const Button = (props, ref) => {
    const {
        children,
        onClick,
        onHover,
        onPress,
        className,
        hoveredClass = className,
        pressedClass = className
    } = props;

    const [isHovered, setHovered] = useState(false);
    const [isPressed, setPressed] = useState(false);

    const classList = classNames(
        { [className]: !isPressed && !isHovered && className },
        { [hoveredClass]: !isPressed && isHovered },
        { [pressedClass]: isPressed }
    );

    const hoverCallback = onHover ?
        (hoveredState) => {
            setHovered(hoveredState);
            onHover(hoveredState);
        }
        : setHovered;

    const pressCallback = onPress ?
        (pressedState) => {
            setPressed(pressedState);
            onPress(pressedState);
        }
        : setPressed;

    const stateRef = useRef();
    const listeners = useButtonListeners(hoverCallback, pressCallback, onClick, stateRef);

    useImperativeHandle(ref, () => ({
        getState: () => ({ ...stateRef.current })
    }), []);

    return <div className={classList} {...listeners}>
        {children}
    </div>;
};

export default forwardRef(Button);
